import React from 'react';

export default function Envelope() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M18.5192 0.178711H0.980769C0.786957 0.178711 0.601083 0.257729 0.464037 0.398381C0.326992 0.539033 0.25 0.729799 0.25 0.928711V13.6787C0.25 14.0765 0.403983 14.4581 0.678075 14.7394C0.952166 15.0207 1.32391 15.1787 1.71154 15.1787H17.7885C18.1761 15.1787 18.5478 15.0207 18.8219 14.7394C19.096 14.4581 19.25 14.0765 19.25 13.6787V0.928711C19.25 0.729799 19.173 0.539033 19.036 0.398381C18.8989 0.257729 18.713 0.178711 18.5192 0.178711ZM7.07447 7.67871L1.71154 12.7234V2.63402L7.07447 7.67871ZM8.15601 8.6959L9.25216 9.73184C9.38698 9.85885 9.56333 9.92933 9.74635 9.92933C9.92936 9.92933 10.1057 9.85885 10.2405 9.73184L11.3367 8.6959L16.6348 13.6787H2.85976L8.15601 8.6959ZM12.4255 7.67871L17.7885 2.63309V12.7243L12.4255 7.67871Z"
        fill="#919BAB"
      />
    </svg>
  );
}
